export const PAGE_ANALYTICS_SOURCE = 'general-board-settings-page';
export const APP_METRIC_KEY = 'boards-setting.general-settings';
